import React from 'react';
import { ShieldCheck, EyeOff, Lock } from 'lucide-react';

const DiscretionSection = () => {
  const trustPoints = [
    {
      icon: EyeOff,
      title: "Keine Veröffentlichung ohne Freigabe",
    },
    {
      icon: Lock,
      title: "Vertrauliche Projektumsetzung",
    },
    {
      icon: ShieldCheck,
      title: "Markensensible Zusammenarbeit",
    },
  ];

  return (
    <section data-testid="discretion-section" className="py-12 lg:py-20 relative">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 right-0 w-[300px] h-[300px] bg-[#88a2ff]/3 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-4xl mx-auto px-4 lg:px-8 relative z-10">
        <div className="p-6 lg:p-14 rounded-3xl bg-white/[0.02] border border-white/[0.06]">
          <h2 className="text-2xl lg:text-4xl font-bold mb-4 lg:mb-5 text-white">
            Diskrete Zusammenarbeit auf Wunsch
          </h2>
          <p className="text-gray-400 text-sm lg:text-base leading-relaxed mb-6 lg:mb-10 max-w-2xl">
            Auf Wunsch veröffentlichen wir weder Marke, Produkte noch finale Visuals. 
            Viele Brands möchten neue Produktionswege zunächst intern oder im Hintergrund 
            testen – genau dafür ist Northlight ausgelegt: vertraulich, markensicher und 
            professionell betreut.
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {trustPoints.map((point, index) => {
              const IconComponent = point.icon;
              return (
                <div
                  key={index}
                  data-testid={`trust-point-${index}`}
                  className="flex items-center gap-3"
                >
                  <div className="w-10 h-10 rounded-xl bg-[#88a2ff]/10 flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-5 h-5 text-[#88a2ff]" />
                  </div>
                  <span className="text-sm text-gray-300 font-medium">
                    {point.title}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscretionSection;
